import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class CommonApiService {
  constructor(private apiService: ApiService) { }

  getModuleTitleListById(id, units) {
    return this.apiService.post('/moduletitlelist/' + id, units).map(data => data);
  }

  /**
   * commentId = null or 0 means fetch all the comments by itemType
   * otherwise fetch the comment by commentId
   */
  getItemCommentsById(id, itemType, commentId) {
    return this.apiService.get('/itemcomments/ItemType/' + itemType + '/' + id + '/' + commentId).map(data => data);
  }

  addItemComment(comment, appid) {
    return this.apiService.post('/itemcomments/' + appid, comment).map(data => data);
  }

  deleteItemComment(id, itemId, itemType, appid) {
    return this.apiService.delete('/itemcomment/app/' + appid + '/itemid/' + itemId + '/itemtype/' + itemType + "/" + id).map(data => data);
  }

  getTotalViewsById(id, type, appId) {
    return this.apiService.get('/totalviews/id/'+id+'/type/' + type + '/appid/' + appId).map(data => data);
  }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/common/common-api-management.ts